import { fr } from '../i18n/fr';

interface PaginationLabelArgs {
  from: number;
  to: number;
  count: number;
}

export const formatPaginationLabel = ({
  from,
  to,
  count,
}: PaginationLabelArgs): string => {
  if (typeof fr.paginationDisplayedRows === 'function') {
    return fr.paginationDisplayedRows({ from, to, count });
  }

  if (count === -1) {
    return `${from}–${to}`;
  }

  return `${from}–${to} / ${count}`;
};
